export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return "0 B";
  
  const k = 1024;
  const sizes = ["B", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  
  return `${parseFloat((bytes / k ** i).toFixed(2))} ${sizes[i]}`;
};

export const formatDate = (dateString: string): string => {
  if (!dateString) return "";
  
  const date = new Date(dateString);
  return date.toLocaleDateString("pl-PL", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
};

export const formatDateTime = (dateString: string): string => {
  if (!dateString) return "";
  
  const date = new Date(dateString);
  return date.toLocaleString("pl-PL", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
};

export const generateDeductionConsentFileName = (
  createdAt: string,
  firstName: string,
  lastName: string,
  language: string
): string => {
  const [date, time = ""] = createdAt.split("T");
  const formattedTime = time.split(".")[0].replace(/:/g, "-");
  const generatedAt = formattedTime ? `${date}_${formattedTime}` : date;
  const prefix =
    language?.toLowerCase() === "en"
      ? "Salary_Deduction_Consent"
      : "Zgoda_na_potracenie";
  return `${prefix}_${firstName}_${lastName}_${generatedAt}.pdf`;
};

export const transformSortParams = (
  sortModel: ReadonlyArray<{ field: string; sort?: string | null }>
): string[] | undefined => {
  if (!sortModel || !sortModel.length) return undefined;

  const sortableFields = new Set(["firstName", "lastName", "lastUpdateDate"]);

  const transformed = sortModel
    .filter(
      ({ field, sort }) =>
        sortableFields.has(field) && (sort === "asc" || sort === "desc")
    )
    .map(({ field, sort }) => `${field},${sort}`);

  return transformed.length ? transformed : undefined;
};

export const transformFilterParams = (filterModel: {
  items: Array<{ field: string; value?: string }>;
}): {
  firstName?: string;
  lastName?: string;
  fk?: string;
} => {
  const params: {
    firstName?: string;
    lastName?: string;
    fk?: string;
  } = {};

  filterModel.items.forEach((item) => {
    if (item.value) {
      switch (item.field) {
        case "firstName":
          params.firstName = item.value;
          break;
        case "lastName":
          params.lastName = item.value;
          break;
        case "fk":
          params.fk = item.value;
          break;
        default:
          break;
      }
    }
  });

  return params;
};

export const calculateDetailPanelHeight = (filesCount: number): number => {
  if (filesCount === 0) return 80;
  const fileRowsHeight = filesCount * 32;
  const dividersHeight = filesCount > 1 ? (filesCount - 1) * 17 : 0;
  const baseHeight = 30;

  return baseHeight + fileRowsHeight + dividersHeight;
};

export const downloadBlobAsFile = (blob: Blob, fileName: string): void => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();

  window.URL.revokeObjectURL(url);
  document.body.removeChild(link);
};

export const getAlternatingRowClassName = <T extends { id: string }>(
  content: T[],
  rowId: string
): string => {
  const index = content.findIndex((row) => row.id === rowId);
  return index % 2 === 0 ? "row-odd" : "row-even";
};
